import { NodeGroupResizable } from "@features/builder/graph/nodes/NodeGroupResizable"
import { CategoricalNode } from "@features/builder/graph/nodes/CategoricalNode"
import { ContinuousNode } from "@features/builder/graph/nodes/ContinuousNode"
import { DeterministicNode } from "@features/builder/graph/nodes/DeterministicNode"
import { EmptyNode } from "@features/builder/graph/nodes/EmptyNode"
import { DiscreteNode } from "@features/builder/graph/nodes/DiscreteNode"
import { ForecastNode } from "@features/builder/graph/nodes/ForecastNode"
import { ScenarioNode } from "@features/builder/graph/nodes/ScenarioNode"
import { LagNode } from "@features/builder/graph/nodes/LagNode"
import { MixtureNode } from "@features/builder/graph/nodes/MixtureNode"
import { TableNode } from "@features/builder/graph/nodes/TableNode"
import { LowDetailNode } from "@features/builder/graph/nodes/LowDetailNode"
import { LowDetailNoTextNode } from "@features/builder/graph/nodes/LowDetailNoTextNode"

export enum NodeLevelOfDetails {
  Detailed,
  WithoutType,
  WithoutText,
}

export const nodeTypesLod1 = {
  group: NodeGroupResizable,
  categorical: CategoricalNode,
  continuous: ContinuousNode,
  deterministic: DeterministicNode,
  empty: EmptyNode,
  discrete: DiscreteNode,
  forecast: ForecastNode,
  scenario: ScenarioNode,
  lag: LagNode,
  mixture: MixtureNode,
  table: TableNode,
  scenarioTable: TableNode,
  forecastTable: TableNode,
}

export const nodeTypesLod2 = {
  group: NodeGroupResizable,
  categorical: LowDetailNode,
  continuous: LowDetailNode,
  deterministic: LowDetailNode,
  empty: LowDetailNode,
  discrete: LowDetailNode,
  forecast: LowDetailNode,
  scenario: LowDetailNode,
  lag: LowDetailNode,
  mixture: LowDetailNode,
  table: LowDetailNode,
  scenarioTable: LowDetailNode,
  forecastTable: LowDetailNode,
}

export const nodeTypesLod3 = {
  group: NodeGroupResizable,
  categorical: LowDetailNoTextNode,
  continuous: LowDetailNoTextNode,
  deterministic: LowDetailNoTextNode,
  empty: LowDetailNoTextNode,
  discrete: LowDetailNoTextNode,
  forecast: LowDetailNoTextNode,
  scenario: LowDetailNoTextNode,
  lag: LowDetailNoTextNode,
  mixture: LowDetailNoTextNode,
  table: LowDetailNoTextNode,
  scenarioTable: LowDetailNoTextNode,
  forecastTable: LowDetailNoTextNode,
}
